import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  "resources": {
    "en": {
      "translation": {
        "products": "Products",
        "about": "About Us",
        "resources": "Resources",
        "featuresHeader": "Features",
        "packages": "Packages",
        "services_header": "Services",
        "bio": "Biography",
        "bio_title": "Welcome to ELYX",
        "bio_description": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
        "bio_services_title": "Our services:",
        "bio_services_list": [
          "Websites",
          "E-commerce",
          "QR menus",
          "Custom business software",
          "SEO",
          "UI/UX design",
          "Cloud and server support",
          "IT maintenance"
        ],
        "bio_tech": "Websites, e-commerce, QR menus, custom business software, SEO, UI/UX, cloud and server support, and IT maintenance.",
        "your_trusted_partner": "Digital solutions for businesses in Armenia",
        "intro_paragraph1": "Websites, e-commerce, QR menus, custom business software, SEO, UI/UX, cloud and server support, and IT maintenance.",
        "intro_paragraph2": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
        "blueprint_title": "Project approach",
        "blueprint_subtitle": "Requirements, implementation and support",
        "blueprint_intro": "Scope, timing and cost are agreed after reviewing your requirements.",
        "blueprint_cta": "Plan this track",
        "blueprint_track": "delivery track",
        "hero_eyebrow": "Digital solutions for businesses in Armenia",
        "hero_secondary_cta": "See what we deliver",
        "hero_panel_title": "Project approach",
        "hero_panel_caption": "Requirements, implementation and support",
        "hero_panel_footer_primary": "Requirements, implementation and support",
        "hero_panel_footer_secondary": "Scope, timing and cost are agreed after reviewing your requirements.",
        "get_started_button": "Discuss your project",
        "free_consultation": "Free Consultation",
        "contact_now": "Contact Now",
        "contactForm": {
          "banner": "CONTACT US",
          "title1": "Get in",
          "title2": "Touch",
          "description": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
          "name": "Name",
          "email": "Email",
          "phone": "Phone Number",
          "message": "How did you find us?",
          "send": "Send",
          "required": "All fields are required.",
          "success": "Email sent successfully!",
          "error": "Failed to send email. Please try again."
        },
        "smartOrder": {
          "badge": "NEW • HoReCa",
          "title": "Smart Order System",
          "description": "Digital menus with content management for restaurants and cafes.",
          "features": [
            "QR Menu & Orders",
            "Waiter App",
            "Kitchen Display System (KDS)",
            "Flexible Admin Panel"
          ],
          "viewDemo": "View Demo",
          "freeConsultation": "Free Consultation",
          "cardChip": "Built for service teams",
          "cardKicker": "Staff stay in sync across tables, kitchen, and checkouts.",
          "liveDemoLabel": "Live demo",
          "goLiveLabel": "Project approach",
          "goLiveValue": "Scope, timing and cost are agreed after reviewing your requirements.",
          "footerText": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English."
        },
        "qrMenu": {
          "metaTitle": "QR Menu System | Modern QR Menus for Restaurants",
          "metaDescription": "Contactless QR menu with admin panel, instant updates, and custom branding. Built for restaurants, cafes, and hotels.",
          "heroEyebrow": "QR menus",
          "heroTitle": "Modern QR Menus with Live Updates",
          "heroLede": "Digital menus with content management for restaurants and cafes.",
          "heroPrimaryCta": "Order now",
          "heroSecondaryCta": "Watch live demo",
          "heroPills": [
            "Admin Panel included",
            "Custom branding",
            "Scope, timing and cost are agreed after reviewing your requirements."
          ],
          "heroDeviceCaption": "Scan to preview your digital menu",
          "examplesHeaderEyebrow": "Other examples",
          "examplesHeaderTitle": "Project examples",
          "examplesHeaderLede": "Digital menus with content management for restaurants and cafes.",
          "visitSite": "Visit site",
          "examples": [
            {
              "name": "Pascali",
              "desc": "French style, simple navigation, no app download required.",
              "url": "https://pascali.am"
            },
            {
              "name": "Dosevn",
              "desc": "Modern UI, fast service, convenient search.",
              "url": "https://dosevn.am"
            },
            {
              "name": "Artshate Eco",
              "desc": "For outdoor venues, eco-friendly, readable structure.",
              "url": "https://artshatecogarden.com"
            },
            {
              "name": "Elyx Work",
              "desc": "Full automation system (QR Menu + Waiter App + KDS).",
              "url": "https://order.elyx.work"
            },
            {
              "name": "Tjvjik",
              "desc": "Restaurant",
              "url": "https://tjvjik.am/"
            },
            {
              "name": "Bombon",
              "desc": "Cafe / Restaurant",
              "url": "https://bombon.am/"
            },
            {
              "name": "Lastiver Resort",
              "desc": "Resort and Restaurant",
              "url": "https://lastiverresort.am/"
            }
          ],
          "featuresEyebrow": "Built for busy teams",
          "featuresTitle": "What you get",
          "featuresSubtitle": "Everything you need to launch fast and keep menus fresh without extra staff time.",
          "features": [
            {
              "title": "Admin Panel",
              "desc": "Add, edit, or hide dishes in seconds without printing costs."
            },
            {
              "title": "Photo-ready menus",
              "desc": "Upload dish photos, set prices, and control availability."
            },
            {
              "title": "Custom branding",
              "desc": "Logo, colors, and typography matched to your venue."
            },
            {
              "title": "Multi-device",
              "desc": "Works on iOS, Android, tablets, and desktop devices."
            },
            {
              "title": "Instant updates",
              "desc": "Publish changes instantly to every table QR."
            },
            {
              "title": "Upsell-ready",
              "desc": "Highlight specials, add modifiers, and surface best sellers."
            }
          ],
          "workflowEyebrow": "How it works",
          "workflowTitle": "From scan to order",
          "steps": [
            {
              "title": "Scan",
              "desc": "Guests scan the table QR—no app required.",
              "icon": "smartphone"
            },
            {
              "title": "Browse & choose",
              "desc": "They see the live menu with photos, filters, and add-ons.",
              "icon": "eye"
            },
            {
              "title": "You control",
              "desc": "Manage everything from the Admin Panel in under a minute.",
              "icon": "settings"
            }
          ],
          "ctaEyebrow": "Admin Panel",
          "ctaTitle": "Manage menus without calling your designer",
          "ctaLede": "Upload photos, adjust prices, hide sold-out items, or highlight specials. Every change syncs instantly across all QR codes.",
          "ctaPrimary": "Talk to us",
          "ctaSecondary": "Book a call",
          "ctaMenuControlsTitle": "Menu controls",
          "ctaMenuControls": [
            "Live edits and scheduling",
            "Categories and availability",
            "Modifiers and add-ons"
          ],
          "ctaBrandingTitle": "Branding",
          "ctaBranding": [
            "Logo, colors, typography",
            "Grid and spacing refined",
            "Supports multiple languages"
          ],
          "pricingEyebrow": "Pricing",
          "pricingTitle": "Pick your rollout",
          "pricingSubtitle": "Scope, timing and cost are agreed after reviewing your requirements.",
          "plans": [
            {
              "name": "Standard",
              "blurb": "Fast launch for cafes and restaurants.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "perks": [
                "Online QR menu",
                "Admin Panel access",
                "Up to 50 dishes"
              ],
              "cta": "Order Standard",
              "badge": "",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Standard%20QR%20Menu%20package"
            },
            {
              "name": "Pro Design",
              "blurb": "Brand-matched QR menu with polished UI.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "badge": "",
              "perks": [
                "Everything in Standard",
                "Custom logo & colors",
                "UI/UX design refresh"
              ],
              "cta": "Order Pro Design",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Pro%20Design%20QR%20Menu%20package"
            },
            {
              "name": "Premium",
              "blurb": "Full flow with ordering and payments.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "badge": "",
              "perks": [
                "Everything in Pro Design",
                "Online ordering",
                "IDram, Telcell, card payments",
                "Order tracking"
              ],
              "cta": "Order Premium",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Premium%20QR%20Menu%20package"
            }
          ],
          "pricingCta": "Start now",
          "faqEyebrow": "FAQ",
          "faqTitle": "Answers before you scan",
          "faqs": [
            {
              "q": "How long does setup take?",
              "a": "Scope, timing and cost are agreed after reviewing your requirements."
            },
            {
              "q": "Can I update the menu myself?",
              "a": "Yes. The Admin Panel is simple—edit items, photos, and prices in seconds."
            },
            {
              "q": "Do guests need an app?",
              "a": "No. Scanning the QR opens the menu in their browser on any device."
            },
            {
              "q": "Can you match our branding?",
              "a": "Absolutely. We mirror your logo, colors, and typography so the menu feels on-brand."
            }
          ],
          "contactEyebrow": "Ready to launch?",
          "contactTitle": "Contact us now",
          "contactPrimary": "Call now",
          "contactSecondary": "Chat on WhatsApp"
        },
        "about_us_title": "About Us",
        "years_experience": "Years of experience",
        "successful_projects": "Successfully completed projects",
        "team_members": "Employees in ELYX team",
        "active_partners": "Active partners",
        "awards_won": "Awards won",
        "customer_satisfaction": "Customer satisfaction",
        "customDev": "Custom business software",
        "ecommerce": "E-commerce",
        "scalableArchitecture": "Cloud and server support",
        "agency": {
          "title": "Digital solutions for businesses in Armenia",
          "intro": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
          "quote": "Scope, timing and cost are agreed after reviewing your requirements.",
          "contact": "Discuss your project",
          "services": [
            {
              "title": "Websites",
              "description": "Business websites and landing pages adapted for mobile devices."
            },
            {
              "title": "E-commerce",
              "description": "Online catalogs and shopping workflows suited to your business."
            },
            {
              "title": "QR menus",
              "description": "Digital menus with content management for restaurants and cafes."
            },
            {
              "title": "Custom business software",
              "description": "Internal tools, integrations and workflow automation."
            },
            {
              "title": "SEO",
              "description": "Technical SEO, site structure and content improvements."
            },
            {
              "title": "UI/UX design",
              "description": "Interface design and user journeys for websites and applications."
            },
            {
              "title": "Cloud and server support",
              "description": "Server configuration, deployment, backups and monitoring by agreement."
            },
            {
              "title": "IT maintenance",
              "description": "Website updates, troubleshooting and ongoing technical support."
            }
          ],
          "resources": "Useful resources",
          "resourceNote": "Independent documentation links; no partnership or endorsement is implied.",
          "faqTitle": "Frequently asked questions",
          "faqs": [
            {
              "question": "How are cost and timing agreed?",
              "answer": "After reviewing scope, integrations and support needs, we agree a proposal before work begins."
            },
            {
              "question": "Which languages can we use?",
              "answer": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English."
            }
          ]
        },
        "features": {
          "closeButton": "Close",
          "ecommerce": {
            "title": "E-commerce",
            "description": "Online catalogs and shopping workflows suited to your business.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "customDev": {
            "title": "Custom business software",
            "description": "Internal tools, integrations and workflow automation.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "mobileAdaptation": {
            "title": "Websites",
            "description": "Business websites and landing pages adapted for mobile devices.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "scalableArchitecture": {
            "title": "Cloud and server support",
            "description": "Server configuration, deployment, backups and monitoring by agreement.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "creativeDesign": {
            "title": "UI/UX design",
            "description": "Interface design and user journeys for websites and applications.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "effectiveCommunication": {
            "title": "IT maintenance",
            "description": "Website updates, troubleshooting and ongoing technical support.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "onTimeDelivery": {
            "title": "QR menus",
            "description": "Digital menus with content management for restaurants and cafes.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "collaborativeApproach": {
            "title": "SEO",
            "description": "Technical SEO, site structure and content improvements.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          }
        }
      }
    },
    "hy": {
      "translation": {
        "products": "Արտադրանքներ",
        "about": "Մեր մասին",
        "resources": "Ռեսուրսներ",
        "featuresHeader": "Հատկություններ",
        "packages": "Փաթեթներ",
        "services_header": "Ծառայություններ",
        "bio": "Կենսագրություն",
        "bio_title": "Բարի գալուստ ELYX",
        "bio_description": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։",
        "bio_services_title": "Մեր ծառայությունները:",
        "bio_services_list": [
          "Կայքեր",
          "Առցանց խանութներ",
          "QR մենյուներ",
          "Անհատական բիզնես ծրագրեր",
          "SEO",
          "UI/UX դիզայն",
          "Ամպային և սերվերային աջակցություն",
          "ՏՏ սպասարկում"
        ],
        "bio_tech": "Կայքեր, առցանց խանութներ, QR մենյուներ, անհատական բիզնես ծրագրեր, SEO, UI/UX, ամպային ու սերվերային աջակցություն և ՏՏ սպասարկում։",
        "your_trusted_partner": "Թվային լուծումներ Հայաստանի բիզնեսների համար",
        "intro_paragraph1": "Կայքեր, առցանց խանութներ, QR մենյուներ, անհատական բիզնես ծրագրեր, SEO, UI/UX, ամպային ու սերվերային աջակցություն և ՏՏ սպասարկում։",
        "intro_paragraph2": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։",
        "blueprint_title": "Աշխատանքի մոտեցումը",
        "blueprint_subtitle": "Պահանջներ, իրականացում և աջակցություն",
        "blueprint_intro": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
        "blueprint_cta": "Պլանավորել այս ուղին",
        "blueprint_track": "առաքման ուղի",
        "hero_eyebrow": "Թվային լուծումներ Հայաստանի բիզնեսների համար",
        "hero_secondary_cta": "Տեսնել մեր գործերը",
        "hero_panel_title": "Աշխատանքի մոտեցումը",
        "hero_panel_caption": "Պահանջներ, իրականացում և աջակցություն",
        "hero_panel_footer_primary": "Պահանջներ, իրականացում և աջակցություն",
        "hero_panel_footer_secondary": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
        "get_started_button": "Քննարկենք ձեր նախագիծը",
        "free_consultation": "Անվճար խորհրդատվություն՝ միայն այսօր։",
        "contact_now": "Կապ հաստատել հիմա",
        "contactForm": {
          "banner": "ԿԱՊ ՄԵԶ ՀԵՏ",
          "title1": "Կապվեք",
          "title2": "Մեզ հետ",
          "description": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։",
          "name": "Անուն",
          "email": "Էլ․ փոստ",
          "phone": "Հեռախոսահամար",
          "message": "Ինչպե՞ս գտաք մեզ:",
          "send": "Ուղարկել",
          "required": "Բոլոր դաշտերը պարտադիր են:",
          "success": "Նամակը հաջողությամբ ուղարկվեց:",
          "error": "Նամակի ուղարկումը ձախողվեց: Խնդրում ենք փորձել կրկին:"
        },
        "smartOrder": {
          "badge": "ՆՈՐՈՒՅԹ • HoReCa",
          "title": "Խելացի Պատվերների Համակարգ",
          "description": "Կառավարվող թվային մենյուներ ռեստորանների և սրճարանների համար։",
          "features": [
            "QR Մենյու և Պատվերներ",
            "Մատուցողի Հավելված",
            "Խոհանոցի Էկրան (KDS)",
            "Ճկուն Կառավարման Վահանակ"
          ],
          "viewDemo": "Դիտել Դեմոն",
          "freeConsultation": "Անվճար Խորհրդատվություն",
          "cardChip": "Ստեղծված է սպասարկման թիմերի համար",
          "cardKicker": "Անձնակազմը սինխրոնիզացված է աշխատում սեղանների, խոհանոցի և դրամարկղի հետ։",
          "liveDemoLabel": "Live դեմո",
          "goLiveLabel": "Աշխատանքի մոտեցումը",
          "goLiveValue": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
          "footerText": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։"
        },
        "qrMenu": {
          "metaTitle": "QR մենյու համակարգ | Ժամանակակից QR մենյուներ ռեստորանների համար",
          "metaDescription": "Անհպում QR մենյու՝ ադմին վահանակով, ակնթարթային թարմացումներով և բրենդավորմամբ։ Ռեստորանների, սրճարանների և հյուրանոցների համար։",
          "heroEyebrow": "QR մենյուներ",
          "heroTitle": "Ժամանակակից QR մենյուներ կենդանի թարմացումներով",
          "heroLede": "Կառավարվող թվային մենյուներ ռեստորանների և սրճարանների համար։",
          "heroPrimaryCta": "Պատվիրել հիմա",
          "heroSecondaryCta": "Դիտել live demo",
          "heroPills": [
            "Վարչական վահանակ",
            "Անհատական բրենդավորում",
            "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          ],
          "heroDeviceCaption": "Սկանավորեք՝ տեսնելու ձեր թվային մենյուն",
          "examplesHeaderEyebrow": "Ուրիշ օրինակներ",
          "examplesHeaderTitle": "Նախագծերի օրինակներ",
          "examplesHeaderLede": "Կառավարվող թվային մենյուներ ռեստորանների և սրճարանների համար։",
          "visitSite": "Այցելել կայքը",
          "examples": [
            {
              "name": "Pascali",
              "desc": "Ֆրանսիական ոճ, պարզ նավիգացիա, առանց հավելվածի բեռնման։",
              "url": "https://pascali.am"
            },
            {
              "name": "Dosevn",
              "desc": "Ժամանակակից UI, արագ սպասարկում, հարմար որոնում։",
              "url": "https://dosevn.am"
            },
            {
              "name": "Artshate Eco",
              "desc": "Բացօթյա վայրերի համար, eco-friendly, ընթեռնելի կառուցվածք։",
              "url": "https://artshatecogarden.com"
            },
            {
              "name": "Elyx Work",
              "desc": "Ավտոմատացման ամբողջական համակարգ (QR Menu + Waiter App + KDS)։",
              "url": "https://order.elyx.work"
            },
            {
              "name": "Tjvjik Ռեստորան",
              "desc": "Ռեստորան",
              "url": "https://tjvjik.am/"
            },
            {
              "name": "Bombon",
              "desc": "Սրճարան / Ռեստորան",
              "url": "https://bombon.am/"
            },
            {
              "name": "Lastiver Resort",
              "desc": "Հանգստյան գոտի և Ռեստորան",
              "url": "https://lastiverresort.am/"
            }
          ],
          "featuresEyebrow": "Ստեղծված զբաղված թիմերի համար",
          "featuresTitle": "Ինչ եք ստանում",
          "featuresSubtitle": "Բոլոր անհրաժեշտ գործիքները, որպեսզի արագ գործարկեք և միշտ թարմ պահեք մենյուն՝ առանց լրացուցիչ անձնակազմի։",
          "features": [
            {
              "title": "Ադմին վահանակ",
              "desc": "Ավելացրեք, խմբագրեք կամ թաքցրեք ուտեստները վայրկյանների ընթացքում՝ առանց տպագրական ծախսերի։"
            },
            {
              "title": "Լուսանկարներով մենյու",
              "desc": "Վերբեռնեք ուտեստների նկարներ, նշեք գներ, կառավարեք հասանելիությունը։"
            },
            {
              "title": "Անհատական բրենդավորում",
              "desc": "Լոգո, գույներ և տառատեսակներ՝ ձեր վայրին համապատասխան։"
            },
            {
              "title": "Բոլոր սարքերում",
              "desc": "Աշխատում է iOS, Android, պլանշետ և desktop սարքերում։"
            },
            {
              "title": "Ակնթարթային թարմացումներ",
              "desc": "Փոփոխությունները անմիջապես հասանելի են բոլոր սեղանների QR-երում։"
            },
            {
              "title": "Ավելի շատ վաճառք",
              "desc": "Ընդգծեք հատուկ առաջարկները, ավելացրեք հավելումներ և ցույց տվեք հիթ ուտեստները։"
            }
          ],
          "workflowEyebrow": "Ինչպես է աշխատում",
          "workflowTitle": "Սկան-ից մինչև պատվեր",
          "steps": [
            {
              "title": "Սկան",
              "desc": "Հյուրերը սեղանի QR-ն սկանավորում են․ հավելված պետք չէ։",
              "icon": "smartphone"
            },
            {
              "title": "Դիտում և ընտրում",
              "desc": "Նրանք տեսնում են կենդանի մենյուն նկարներով, ֆիլտրերով ու հավելումներով։",
              "icon": "eye"
            },
            {
              "title": "Դուք կառավարում եք",
              "desc": "Ամեն ինչ վերահսկում եք ադմին վահանակից՝ մեկ րոպեում։",
              "icon": "settings"
            }
          ],
          "ctaEyebrow": "Ադմին վահանակ",
          "ctaTitle": "Կառավարեք մենյուն առանց դիզայներին զանգելու",
          "ctaLede": "Վերբեռնեք լուսանկարներ, փոխեք գները, թաքցրեք սպառվածը կամ ընդգծեք special-ները։ Ամեն փոփոխություն անմիջապես հասանելի է բոլոր QR-երում։",
          "ctaPrimary": "Կապվեք մեզ հետ",
          "ctaSecondary": "Ամրագրել զանգ",
          "ctaMenuControlsTitle": "Մենյուի կառավարում",
          "ctaMenuControls": [
            "Կենդանի փոփոխություններ և ժամանակագրում",
            "Կատեգորիաներ և հասանելիություն",
            "Հավելումներ և մոդիֆիկատորներ"
          ],
          "ctaBrandingTitle": "Բրենդավորում",
          "ctaBranding": [
            "Լոգո, գույներ, տառատեսակ",
            "Ճշտված ցանց և բացվածքներ",
            "Բազմալեզու աջակցություն"
          ],
          "pricingEyebrow": "Գին",
          "pricingTitle": "Ընտրեք փաթեթը",
          "pricingSubtitle": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
          "plans": [
            {
              "name": "Standard",
              "blurb": "Արագ գործարկում սրճարանների և ռեստորանների համար։",
              "price": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
              "perks": [
                "Առցանց QR մենյու",
                "Ադմին վահանակի հասանելիություն",
                "Մինչև 50 ուտեստ"
              ],
              "cta": "Պատվիրել Standard",
              "badge": "",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Standard%20QR%20Menu%20package"
            },
            {
              "name": "Pro Design",
              "blurb": "Բրենդին համահունչ QR մենյու և UI փայլեցում։",
              "price": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
              "badge": "",
              "perks": [
                "Բոլորը՝ Standard-ից",
                "Անհատական լոգո և գույներ",
                "UI/UX ձևավորման թարմացում"
              ],
              "cta": "Պատվիրել Pro Design",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Pro%20Design%20QR%20Menu%20package"
            },
            {
              "name": "Premium",
              "blurb": "Լրիվ հոսք՝ պատվերների և վճարումների ինտեգրումով։",
              "price": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
              "badge": "",
              "perks": [
                "Բոլորը՝ Pro Design-ից",
                "Առցանց պատվերներ",
                "IDram, Telcell, քարտային վճարումներ",
                "Պատվերի հետևում"
              ],
              "cta": "Պատվիրել Premium",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Premium%20QR%20Menu%20package"
            }
          ],
          "pricingCta": "Սկսել հիմա",
          "faqEyebrow": "ՀՏՀ",
          "faqTitle": "Պատասխաններ մինչև սկանավորելը",
          "faqs": [
            {
              "q": "Քանի՞ ժամանակ է պետք կարգավորմանը։",
              "a": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
            },
            {
              "q": "Կարո՞ղ եմ ինքս թարմացնել մենյուն։",
              "a": "Այո։ Ադմին վահանակը պարզ է՝ կարող եք վայրկյանների ընթացքում փոխել ապրանքներ, նկարներ և գներ։"
            },
            {
              "q": "Հյուրերին հավելված պե՞տք է։",
              "a": "Ոչ։ QR-ը բացում է մենյուն բրաուզերում ցանկացած սարքում։"
            },
            {
              "q": "Կկարողանա՞ք համահունչ լինել մեր բրենդին։",
              "a": "Իհարկե։ Համադրում ենք լոգոն, գույներն ու տառատեսակը, որպեսզի մենյուն ձեր ոճով լինի։"
            }
          ],
          "contactEyebrow": "Պատրա՞ստ եք գործարկել",
          "contactTitle": "Կապվեք հիմա",
          "contactPrimary": "Զանգահարել հիմա",
          "contactSecondary": "Գրել WhatsApp-ում"
        },
        "about_us_title": "Մեր Մասին",
        "years_experience": "Տարի փորձ ոլորտում",
        "successful_projects": "Հաջողությամբ ավարտված նախագծեր",
        "team_members": "Աշխատակիցներ ELYX թիմում",
        "active_partners": "Գործող գործընկերներ",
        "awards_won": "Շահած մրցանակներ",
        "customer_satisfaction": "Հաճախորդների գոհունակություն",
        "customDev": "Անհատական բիզնես ծրագրեր",
        "ecommerce": "Առցանց խանութներ",
        "scalableArchitecture": "Ամպային և սերվերային աջակցություն",
        "agency": {
          "title": "Թվային լուծումներ Հայաստանի բիզնեսների համար",
          "intro": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։",
          "quote": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։",
          "contact": "Քննարկենք ձեր նախագիծը",
          "services": [
            {
              "title": "Կայքեր",
              "description": "Բիզնես կայքեր և լենդինգներ՝ հարմարեցված բջջային սարքերին։"
            },
            {
              "title": "Առցանց խանութներ",
              "description": "Առցանց կատալոգներ և գնումների գործընթացներ՝ ըստ բիզնեսի կարիքների։"
            },
            {
              "title": "QR մենյուներ",
              "description": "Կառավարվող թվային մենյուներ ռեստորանների և սրճարանների համար։"
            },
            {
              "title": "Անհատական բիզնես ծրագրեր",
              "description": "Ներքին գործիքներ, ինտեգրումներ և աշխատանքային գործընթացների ավտոմատացում։"
            },
            {
              "title": "SEO",
              "description": "Տեխնիկական SEO, կայքի կառուցվածքի և բովանդակության բարելավում։"
            },
            {
              "title": "UI/UX դիզայն",
              "description": "Կայքերի և հավելվածների միջերեսների ու օգտատիրոջ ուղիների նախագծում։"
            },
            {
              "title": "Ամպային և սերվերային աջակցություն",
              "description": "Սերվերների կարգավորում, տեղակայում, պահուստավորում և մոնիթորինգ՝ ըստ համաձայնության։"
            },
            {
              "title": "ՏՏ սպասարկում",
              "description": "Կայքերի թարմացում, խնդիրների լուծում և շարունակական տեխնիկական աջակցություն։"
            }
          ],
          "resources": "Օգտակար ռեսուրսներ",
          "resourceNote": "Անկախ փաստաթղթերի հղումներ․ դրանք չեն ենթադրում գործընկերություն կամ երաշխավորություն։",
          "faqTitle": "Հաճախ տրվող հարցեր",
          "faqs": [
            {
              "question": "Ինչպե՞ս են որոշվում արժեքն ու ժամկետները։",
              "answer": "Ուսումնասիրում ենք ծավալը, ինտեգրումներն ու սպասարկման կարիքները և համաձայնեցնում առաջարկը՝ նախքան աշխատանքը։"
            },
            {
              "question": "Ի՞նչ լեզուներով կարող ենք հաղորդակցվել։",
              "answer": "Աշխատում ենք Հայաստանի և ռուսախոս բնակիչների ու բիզնեսների հետ՝ հայերեն, ռուսերեն և անգլերեն հաղորդակցությամբ։"
            }
          ]
        },
        "features": {
          "closeButton": "Փակել",
          "ecommerce": {
            "title": "Առցանց խանութներ",
            "description": "Առցանց կատալոգներ և գնումների գործընթացներ՝ ըստ բիզնեսի կարիքների։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "customDev": {
            "title": "Անհատական բիզնես ծրագրեր",
            "description": "Ներքին գործիքներ, ինտեգրումներ և աշխատանքային գործընթացների ավտոմատացում։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "mobileAdaptation": {
            "title": "Կայքեր",
            "description": "Բիզնես կայքեր և լենդինգներ՝ հարմարեցված բջջային սարքերին։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "scalableArchitecture": {
            "title": "Ամպային և սերվերային աջակցություն",
            "description": "Սերվերների կարգավորում, տեղակայում, պահուստավորում և մոնիթորինգ՝ ըստ համաձայնության։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "creativeDesign": {
            "title": "UI/UX դիզայն",
            "description": "Կայքերի և հավելվածների միջերեսների ու օգտատիրոջ ուղիների նախագծում։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "effectiveCommunication": {
            "title": "ՏՏ սպասարկում",
            "description": "Կայքերի թարմացում, խնդիրների լուծում և շարունակական տեխնիկական աջակցություն։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "onTimeDelivery": {
            "title": "QR մենյուներ",
            "description": "Կառավարվող թվային մենյուներ ռեստորանների և սրճարանների համար։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          },
          "collaborativeApproach": {
            "title": "SEO",
            "description": "Տեխնիկական SEO, կայքի կառուցվածքի և բովանդակության բարելավում։",
            "detailedText": "Ծավալը, ժամկետներն ու արժեքը համաձայնեցնում ենք պահանջները ուսումնասիրելուց հետո։"
          }
        }
      }
    },
    "ru": {
      "translation": {
        "products": "Продукты",
        "about": "О нас",
        "resources": "Ресурсы",
        "featuresHeader": "Функции",
        "packages": "Пакеты",
        "services_header": "Услуги",
        "bio": "Биография",
        "free_consultation": "Бесплатная консультация только сегодня.",
        "contact_now": "Свяжитесь с нами",
        "contactForm": {
          "banner": "СВЯЗАТЬСЯ С НАМИ",
          "title1": "Свяжитесь с",
          "title2": "Нами",
          "description": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском.",
          "name": "Имя",
          "email": "Email",
          "phone": "Номер телефона",
          "message": "Как вы нас нашли?",
          "send": "Отправить",
          "required": "Все поля обязательны для заполнения.",
          "success": "Письмо успешно отправлено!",
          "error": "Не удалось отправить письмо. Пожалуйста, попробуйте еще раз."
        },
        "bio_title": "Добро пожаловать в ELYX",
        "bio_description": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском.",
        "bio_services_title": "Наши услуги:",
        "bio_services_list": [
          "Сайты",
          "Интернет-магазины",
          "QR-меню",
          "Программы для бизнеса",
          "SEO",
          "UI/UX-дизайн",
          "Поддержка облаков и серверов",
          "ИТ-обслуживание"
        ],
        "bio_tech": "Сайты, интернет-магазины, QR-меню, программы для бизнеса, SEO, UI/UX, поддержка облаков и серверов, ИТ-обслуживание.",
        "smartOrder": {
          "badge": "НОВИНКА • HoReCa",
          "title": "Умная Система Заказов",
          "description": "Цифровые меню с управлением контентом для ресторанов и кафе.",
          "features": [
            "QR-меню и заказы",
            "Приложение для официанта",
            "Экран для кухни (KDS)",
            "Гибкая панель управления"
          ],
          "viewDemo": "Смотреть демо",
          "freeConsultation": "Бесплатная консультация",
          "cardChip": "Создано для команд обслуживания",
          "cardKicker": "Персонал работает синхронно за столиками, на кухне и кассе.",
          "liveDemoLabel": "Live демо",
          "goLiveLabel": "Подход к проекту",
          "goLiveValue": "Объём, сроки и стоимость согласуем после изучения требований.",
          "footerText": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском."
        },
        "qrMenu": {
          "metaTitle": "Система QR-меню | Современные QR-меню для ресторанов",
          "metaDescription": "Бесконтактное QR-меню с админ-панелью, мгновенными обновлениями и индивидуальным брендингом. Для ресторанов, кафе и отелей.",
          "heroEyebrow": "QR-меню",
          "heroTitle": "Современные QR-меню с живыми обновлениями",
          "heroLede": "Цифровые меню с управлением контентом для ресторанов и кафе.",
          "heroPrimaryCta": "Заказать сейчас",
          "heroDeviceCaption": "Отсканируйте, чтобы увидеть ваше цифровое меню",
          "heroPills": [
            "Админ-панель",
            "Индивидуальный брендинг",
            "Объём, сроки и стоимость согласуем после изучения требований."
          ],
          "examplesHeaderEyebrow": "Другие примеры",
          "examplesHeaderTitle": "Примеры проектов",
          "examplesHeaderLede": "Цифровые меню с управлением контентом для ресторанов и кафе.",
          "visitSite": "Посетить сайт",
          "examples": [
            {
              "name": "Pascali",
              "desc": "Французский стиль, простая навигация, без скачивания приложения.",
              "url": "https://pascali.am"
            },
            {
              "name": "Dosevn",
              "desc": "Современный UI, быстрое обслуживание, удобный поиск.",
              "url": "https://dosevn.am"
            },
            {
              "name": "Artshate Eco",
              "desc": "Для заведений на открытом воздухе, eco-friendly, читаемая структура.",
              "url": "https://artshatecogarden.com"
            },
            {
              "name": "Elyx Work",
              "desc": "Полная система автоматизации (QR-меню + приложение официанта + KDS).",
              "url": "https://order.elyx.work"
            },
            {
              "name": "Tjvjik",
              "desc": "Ресторан",
              "url": "https://tjvjik.am/"
            },
            {
              "name": "Bombon",
              "desc": "Кафе / Ресторан",
              "url": "https://bombon.am/"
            },
            {
              "name": "Lastiver Resort",
              "desc": "База отдыха и Ресторан",
              "url": "https://lastiverresort.am/"
            }
          ],
          "featuresEyebrow": "Создано для занятых команд",
          "featuresTitle": "Что вы получаете",
          "featuresSubtitle": "Все необходимые инструменты для быстрого запуска и свежего меню без дополнительных сотрудников.",
          "features": [
            {
              "title": "Админ-панель",
              "desc": "Добавляйте, редактируйте или скрывайте блюда за секунды без затрат на печать."
            },
            {
              "title": "Меню с фото",
              "desc": "Загружайте фото блюд, указывайте цены, управляйте наличием."
            },
            {
              "title": "Индивидуальный брендинг",
              "desc": "Логотип, цвета и шрифты, подходящие вашему заведению."
            },
            {
              "title": "На всех устройствах",
              "desc": "Работает на iOS, Android, планшетах и десктопах."
            },
            {
              "title": "Мгновенные обновления",
              "desc": "Изменения сразу доступны на QR-кодах всех столов."
            },
            {
              "title": "Больше продаж",
              "desc": "Выделяйте спецпредложения, добавляйте опции и показывайте хиты продаж."
            }
          ],
          "workflowEyebrow": "Как это работает",
          "workflowTitle": "От сканирования до заказа",
          "steps": [
            {
              "title": "Скан",
              "desc": "Гости сканируют QR-код на столе. Приложение не требуется.",
              "icon": "smartphone"
            },
            {
              "title": "Просмотр и выбор",
              "desc": "Они видят живое меню с фото, фильтрами и дополнениями.",
              "icon": "eye"
            },
            {
              "title": "Вы управляете",
              "desc": "Вы контролируете всё из админ-панели за минуту.",
              "icon": "settings"
            }
          ],
          "ctaEyebrow": "Админ-панель",
          "ctaTitle": "Управляйте меню без звонков дизайнеру",
          "ctaLede": "Загружайте фото, меняйте цены, скрывайте распроданное или выделяйте акции. Любое изменение мгновенно отображается на всех QR-кодах.",
          "pricingEyebrow": "Цена",
          "pricingTitle": "Выберите пакет",
          "pricingSubtitle": "Объём, сроки и стоимость согласуем после изучения требований.",
          "plans": [
            {
              "name": "Standard",
              "blurb": "Быстрый запуск для кафе и ресторанов.",
              "price": "Объём, сроки и стоимость согласуем после изучения требований.",
              "cta": "Заказать Standard",
              "badge": "",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Standard%20QR%20Menu%20package"
            },
            {
              "name": "Pro Design",
              "blurb": "Брендированное QR-меню и проработка UI.",
              "price": "Объём, сроки и стоимость согласуем после изучения требований.",
              "badge": "",
              "cta": "Заказать Pro Design",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Pro%20Design%20QR%20Menu%20package"
            },
            {
              "name": "Premium",
              "blurb": "Полный цикл с интеграцией заказов и оплат.",
              "price": "Объём, сроки и стоимость согласуем после изучения требований.",
              "badge": "",
              "cta": "Заказать Premium",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Premium%20QR%20Menu%20package"
            }
          ],
          "faqEyebrow": "FAQ",
          "faqTitle": "Ответы перед сканированием",
          "faqs": [
            {
              "q": "Сколько времени занимает настройка?",
              "a": "Объём, сроки и стоимость согласуем после изучения требований."
            },
            {
              "q": "Могу ли я сам обновлять меню?",
              "a": "Да. Админ-панель проста — вы можете менять товары, фото и цены за секунды."
            },
            {
              "q": "Нужно ли гостям приложение?",
              "a": "Нет. QR-код открывает меню в браузере на любом устройстве."
            },
            {
              "q": "Сможете ли вы подстроиться под наш бренд?",
              "a": "Конечно. Мы переносим логотип, цвета и шрифты, чтобы меню было в вашем стиле."
            }
          ],
          "contactEyebrow": "Готовы к запуску?",
          "contactTitle": "Свяжитесь сейчас",
          "contactPrimary": "Позвонить сейчас",
          "contactSecondary": "Написать в WhatsApp"
        },
        "about_us_title": "О нас",
        "years_experience": "Лет опыта",
        "successful_projects": "Успешных проектов",
        "team_members": "Сотрудников в команде",
        "active_partners": "Активных партнеров",
        "awards_won": "Выигранных наград",
        "customer_satisfaction": "Удовлетворенность клиентов",
        "your_trusted_partner": "Цифровые решения для бизнеса в Армении",
        "intro_paragraph1": "Сайты, интернет-магазины, QR-меню, программы для бизнеса, SEO, UI/UX, поддержка облаков и серверов, ИТ-обслуживание.",
        "intro_paragraph2": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском.",
        "hero_eyebrow": "Цифровые решения для бизнеса в Армении",
        "get_started_button": "Обсудить проект",
        "blueprint_title": "Подход к проекту",
        "blueprint_subtitle": "Требования, реализация и поддержка",
        "blueprint_intro": "Объём, сроки и стоимость согласуем после изучения требований.",
        "hero_panel_title": "Подход к проекту",
        "hero_panel_caption": "Требования, реализация и поддержка",
        "hero_panel_footer_primary": "Требования, реализация и поддержка",
        "hero_panel_footer_secondary": "Объём, сроки и стоимость согласуем после изучения требований.",
        "customDev": "Программы для бизнеса",
        "ecommerce": "Интернет-магазины",
        "scalableArchitecture": "Поддержка облаков и серверов",
        "agency": {
          "title": "Цифровые решения для бизнеса в Армении",
          "intro": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском.",
          "quote": "Объём, сроки и стоимость согласуем после изучения требований.",
          "contact": "Обсудить проект",
          "services": [
            {
              "title": "Сайты",
              "description": "Сайты для бизнеса и посадочные страницы с адаптацией для мобильных устройств."
            },
            {
              "title": "Интернет-магазины",
              "description": "Онлайн-каталоги и процессы покупок под задачи бизнеса."
            },
            {
              "title": "QR-меню",
              "description": "Цифровые меню с управлением контентом для ресторанов и кафе."
            },
            {
              "title": "Программы для бизнеса",
              "description": "Внутренние инструменты, интеграции и автоматизация рабочих процессов."
            },
            {
              "title": "SEO",
              "description": "Техническое SEO, улучшение структуры сайта и контента."
            },
            {
              "title": "UI/UX-дизайн",
              "description": "Проектирование интерфейсов и пользовательских сценариев сайтов и приложений."
            },
            {
              "title": "Поддержка облаков и серверов",
              "description": "Настройка серверов, развёртывание, резервное копирование и мониторинг по договорённости."
            },
            {
              "title": "ИТ-обслуживание",
              "description": "Обновления сайтов, устранение неполадок и техническое сопровождение."
            }
          ],
          "resources": "Полезные ресурсы",
          "resourceNote": "Ссылки на независимую документацию не означают партнёрство или одобрение.",
          "faqTitle": "Частые вопросы",
          "faqs": [
            {
              "question": "Как определяются стоимость и сроки?",
              "answer": "Изучаем объём, интеграции и потребности в поддержке, затем согласуем предложение до начала работ."
            },
            {
              "question": "На каких языках можно общаться?",
              "answer": "Работаем с жителями и бизнесом Армении, включая русскоязычных клиентов. Общаемся на армянском, русском и английском."
            }
          ]
        },
        "features": {
          "closeButton": "Закрыть",
          "ecommerce": {
            "title": "Интернет-магазины",
            "description": "Онлайн-каталоги и процессы покупок под задачи бизнеса.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "customDev": {
            "title": "Программы для бизнеса",
            "description": "Внутренние инструменты, интеграции и автоматизация рабочих процессов.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "mobileAdaptation": {
            "title": "Сайты",
            "description": "Сайты для бизнеса и посадочные страницы с адаптацией для мобильных устройств.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "scalableArchitecture": {
            "title": "Поддержка облаков и серверов",
            "description": "Настройка серверов, развёртывание, резервное копирование и мониторинг по договорённости.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "creativeDesign": {
            "title": "UI/UX-дизайн",
            "description": "Проектирование интерфейсов и пользовательских сценариев сайтов и приложений.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "effectiveCommunication": {
            "title": "ИТ-обслуживание",
            "description": "Обновления сайтов, устранение неполадок и техническое сопровождение.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "onTimeDelivery": {
            "title": "QR-меню",
            "description": "Цифровые меню с управлением контентом для ресторанов и кафе.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          },
          "collaborativeApproach": {
            "title": "SEO",
            "description": "Техническое SEO, улучшение структуры сайта и контента.",
            "detailedText": "Объём, сроки и стоимость согласуем после изучения требований."
          }
        }
      }
    },
    "el": {
      "translation": {
        "products": "Προϊόντα",
        "about": "Σχετικά με εμάς",
        "resources": "Πόροι",
        "featuresHeader": "Χαρακτηριστικά",
        "packages": "Πακέτα",
        "services_header": "Υπηρεσίες",
        "bio": "Βιογραφία",
        "free_consultation": "Δωρεάν διαβούλευση μόνο σήμερα.",
        "contact_now": "Επικοινωνήστε τώρα",
        "contactForm": {
          "banner": "ΕΠΙΚΟΙΝΩΝΙΑ",
          "title1": "Ελάτε σε",
          "title2": "Επαφή",
          "description": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
          "name": "Όνομα",
          "email": "Email",
          "phone": "Αριθμός Τηλεφώνου",
          "message": "Πώς μας βρήκατε;",
          "send": "Αποστολή",
          "required": "Όλα τα πεδία είναι υποχρεωτικά.",
          "success": "Το email στάλθηκε με επιτυχία!",
          "error": "Αποτυχία αποστολής email. Παρακαλώ δοκιμάστε ξανά."
        },
        "bio_title": "Καλώς ήρθατε στην ELYX",
        "bio_description": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
        "bio_services_title": "Οι υπηρεσίες μας:",
        "bio_services_list": [
          "Websites",
          "E-commerce",
          "QR menus",
          "Custom business software",
          "SEO",
          "UI/UX design",
          "Cloud and server support",
          "IT maintenance"
        ],
        "bio_tech": "Websites, e-commerce, QR menus, custom business software, SEO, UI/UX, cloud and server support, and IT maintenance.",
        "smartOrder": {
          "badge": "ΝΕΟ • HoReCa",
          "title": "Έξυπνο Σύστημα Παραγγελιών",
          "description": "Digital menus with content management for restaurants and cafes.",
          "features": [
            "Μενού QR & Παραγγελίες",
            "Εφαρμογή Σερβιτόρου",
            "Οθόνη Κουζίνας (KDS)",
            "Ευέλικτος Πίνακας Διαχείρισης"
          ],
          "viewDemo": "Προβολή Demo",
          "freeConsultation": "Δωρεάν Διαβούλευση",
          "cardChip": "Δημιουργήθηκε για ομάδες εξυπηρέτησης",
          "cardKicker": "Το προσωπικό παραμένει συγχρονισμένο σε τραπέζια, κουζίνα και ταμεία.",
          "liveDemoLabel": "Live demo",
          "goLiveLabel": "Project approach",
          "goLiveValue": "Scope, timing and cost are agreed after reviewing your requirements.",
          "footerText": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English."
        },
        "qrMenu": {
          "metaTitle": "Σύστημα μενού QR | Σύγχρονα μενού QR για εστιατόρια",
          "metaDescription": "Ανέπαφο μενού QR με πίνακα διαχείρισης, άμεσες ενημερώσεις και προσαρμοσμένη επωνυμία. Για εστιατόρια, καφετέριες και ξενοδοχεία.",
          "heroEyebrow": "QR menus",
          "heroTitle": "Σύγχρονα μενού QR με ζωντανές ενημερώσεις",
          "heroLede": "Digital menus with content management for restaurants and cafes.",
          "heroPrimaryCta": "Παραγγείλετε τώρα",
          "heroDeviceCaption": "Σαρώστε για να δείτε το ψηφιακό σας μενού",
          "heroPills": [
            "Πίνακας Διαχείρισης",
            "Προσαρμοσμένη επωνυμία",
            "Scope, timing and cost are agreed after reviewing your requirements."
          ],
          "examplesHeaderEyebrow": "Άλλα παραδείγματα",
          "examplesHeaderTitle": "Project examples",
          "examplesHeaderLede": "Digital menus with content management for restaurants and cafes.",
          "visitSite": "Επισκεφθείτε την ιστοσελίδα",
          "examples": [
            {
              "name": "Pascali",
              "desc": "Γαλλικό στυλ, απλή πλοήγηση, δεν απαιτείται λήψη εφαρμογής.",
              "url": "https://pascali.am"
            },
            {
              "name": "Dosevn",
              "desc": "Σύγχρονο UI, γρήγορη εξυπηρέτηση, βολική αναζήτηση.",
              "url": "https://dosevn.am"
            },
            {
              "name": "Artshate Eco",
              "desc": "Για υπαίθριους χώρους, φιλικό προς το περιβάλλον, ευανάγνωστη δομή.",
              "url": "https://artshatecogarden.com"
            },
            {
              "name": "Elyx Work",
              "desc": "Πλήρες σύστημα αυτοματισμού (Μενού QR + Εφαρμογή Σερβιτόρου + KDS).",
              "url": "https://order.elyx.work"
            },
            {
              "name": "Tjvjik",
              "desc": "Εστιατόριο",
              "url": "https://tjvjik.am/"
            },
            {
              "name": "Bombon",
              "desc": "Καφετέρια / Εστιατόριο",
              "url": "https://bombon.am/"
            },
            {
              "name": "Lastiver Resort",
              "desc": "Θέρετρο και Εστιατόριο",
              "url": "https://lastiverresort.am/"
            }
          ],
          "featuresEyebrow": "Δημιουργήθηκε για απασχολημένες ομάδες",
          "featuresTitle": "Τι λαμβάνετε",
          "featuresSubtitle": "Όλα τα απαραίτητα εργαλεία για να ξεκινήσετε γρήγορα και να διατηρήσετε το μενού φρέσκο χωρίς επιπλέον προσωπικό.",
          "features": [
            {
              "title": "Πίνακας Διαχείρισης",
              "desc": "Προσθέστε, επεξεργαστείτε ή κρύψτε πιάτα σε δευτερόλεπτα χωρίς κόστος εκτύπωσης."
            },
            {
              "title": "Μενού με φωτογραφίες",
              "desc": "Ανεβάστε φωτογραφίες πιάτων, καθορίστε τιμές, διαχειριστείτε τη διαθεσιμότητα."
            },
            {
              "title": "Προσαρμοσμένη επωνυμία",
              "desc": "Λογότυπο, χρώματα και γραμματοσειρές που ταιριάζουν στον χώρο σας."
            },
            {
              "title": "Σε όλες τις συσκευές",
              "desc": "Λειτουργεί σε iOS, Android, tablet και επιτραπέζιους υπολογιστές."
            },
            {
              "title": "Άμεσες ενημερώσεις",
              "desc": "Οι αλλαγές είναι άμεσα διαθέσιμες στα QR όλων των τραπεζιών."
            },
            {
              "title": "Περισσότερες πωλήσεις",
              "desc": "Επισημάνετε ειδικές προσφορές, προσθέστε επιλογές και δείξτε τα κορυφαία σε πωλήσεις."
            }
          ],
          "workflowEyebrow": "Πώς λειτουργεί",
          "workflowTitle": "Από τη σάρωση στην παραγγελία",
          "steps": [
            {
              "title": "Σάρωση",
              "desc": "Οι επισκέπτες σαρώνουν το QR στο τραπέζι. Δεν απαιτείται εφαρμογή.",
              "icon": "smartphone"
            },
            {
              "title": "Προβολή & Επιλογή",
              "desc": "Βλέπουν το ζωντανό μενού με φωτογραφίες, φίλτρα και προσθήκες.",
              "icon": "eye"
            },
            {
              "title": "Εσείς ελέγχετε",
              "desc": "Ελέγχετε τα πάντα από τον πίνακα διαχείρισης σε ένα λεπτό.",
              "icon": "settings"
            }
          ],
          "ctaEyebrow": "Πίνακας Διαχείρισης",
          "ctaTitle": "Διαχειριστείτε το μενού χωρίς να καλέσετε σχεδιαστή",
          "ctaLede": "Ανεβάστε φωτογραφίες, αλλάξτε τιμές, κρύψτε τα εξαντλημένα ή επισημάνετε τις προσφορές. Κάθε αλλαγή συγχρονίζεται άμεσα σε όλα τα QR.",
          "pricingEyebrow": "Τιμολόγηση",
          "pricingTitle": "Επιλέξτε πακέτο",
          "pricingSubtitle": "Scope, timing and cost are agreed after reviewing your requirements.",
          "plans": [
            {
              "name": "Standard",
              "blurb": "Γρήγορη εκκίνηση για καφετέριες και εστιατόρια.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "cta": "Παραγγελία Standard",
              "badge": "",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Standard%20QR%20Menu%20package"
            },
            {
              "name": "Pro Design",
              "blurb": "Επώνυμο μενού QR και βελτίωση UI.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "badge": "",
              "cta": "Παραγγελία Pro Design",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Pro%20Design%20QR%20Menu%20package"
            },
            {
              "name": "Premium",
              "blurb": "Πλήρης ροή με ενσωμάτωση παραγγελιών και πληρωμών.",
              "price": "Scope, timing and cost are agreed after reviewing your requirements.",
              "badge": "",
              "cta": "Παραγγελία Premium",
              "link": "https://wa.me/+37443099070?text=I%20want%20the%20Premium%20QR%20Menu%20package"
            }
          ],
          "faqEyebrow": "Συχνές Ερωτήσεις",
          "faqTitle": "Απαντήσεις πριν σαρώσετε",
          "faqs": [
            {
              "q": "Πόσος χρόνος χρειάζεται για τη ρύθμιση;",
              "a": "Scope, timing and cost are agreed after reviewing your requirements."
            },
            {
              "q": "Μπορώ να ενημερώσω μόνος μου το μενού;",
              "a": "Ναι. Ο Πίνακας Διαχείρισης είναι απλός - μπορείτε να αλλάξετε αντικείμενα, φωτογραφίες και τιμές σε δευτερόλεπτα."
            },
            {
              "q": "Χρειάζονται εφαρμογή οι πελάτες;",
              "a": "Όχι. Το QR ανοίγει το μενού στο πρόγραμμα περιήγησης σε οποιαδήποτε συσκευή."
            },
            {
              "q": "Μπορείτε να ταιριάξετε με την επωνυμία μας;",
              "a": "Φυσικά. Προσαρμόζουμε το λογότυπο, τα χρώματα και την τυπογραφία, ώστε το μενού να είναι στο στυλ σας."
            }
          ],
          "contactEyebrow": "Έτοιμοι για εκκίνηση;",
          "contactTitle": "Επικοινωνήστε τώρα",
          "contactPrimary": "Καλέστε τώρα",
          "contactSecondary": "Μιλήστε στο WhatsApp"
        },
        "about_us_title": "Σχετικά με εμάς",
        "years_experience": "Χρόνια εμπειρίας",
        "successful_projects": "Επιτυχημένα έργα",
        "team_members": "Μέλη ομάδας",
        "active_partners": "Ενεργοί συνεργάτες",
        "awards_won": "Βραβεία",
        "customer_satisfaction": "Ικανοποίηση πελατών",
        "your_trusted_partner": "Digital solutions for businesses in Armenia",
        "intro_paragraph1": "Websites, e-commerce, QR menus, custom business software, SEO, UI/UX, cloud and server support, and IT maintenance.",
        "intro_paragraph2": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
        "hero_eyebrow": "Digital solutions for businesses in Armenia",
        "get_started_button": "Discuss your project",
        "blueprint_title": "Project approach",
        "blueprint_subtitle": "Requirements, implementation and support",
        "blueprint_intro": "Scope, timing and cost are agreed after reviewing your requirements.",
        "hero_panel_title": "Project approach",
        "hero_panel_caption": "Requirements, implementation and support",
        "hero_panel_footer_primary": "Requirements, implementation and support",
        "hero_panel_footer_secondary": "Scope, timing and cost are agreed after reviewing your requirements.",
        "customDev": "Custom business software",
        "ecommerce": "E-commerce",
        "scalableArchitecture": "Cloud and server support",
        "agency": {
          "title": "Digital solutions for businesses in Armenia",
          "intro": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English.",
          "quote": "Scope, timing and cost are agreed after reviewing your requirements.",
          "contact": "Discuss your project",
          "services": [
            {
              "title": "Websites",
              "description": "Business websites and landing pages adapted for mobile devices."
            },
            {
              "title": "E-commerce",
              "description": "Online catalogs and shopping workflows suited to your business."
            },
            {
              "title": "QR menus",
              "description": "Digital menus with content management for restaurants and cafes."
            },
            {
              "title": "Custom business software",
              "description": "Internal tools, integrations and workflow automation."
            },
            {
              "title": "SEO",
              "description": "Technical SEO, site structure and content improvements."
            },
            {
              "title": "UI/UX design",
              "description": "Interface design and user journeys for websites and applications."
            },
            {
              "title": "Cloud and server support",
              "description": "Server configuration, deployment, backups and monitoring by agreement."
            },
            {
              "title": "IT maintenance",
              "description": "Website updates, troubleshooting and ongoing technical support."
            }
          ],
          "resources": "Useful resources",
          "resourceNote": "Independent documentation links; no partnership or endorsement is implied.",
          "faqTitle": "Frequently asked questions",
          "faqs": [
            {
              "question": "How are cost and timing agreed?",
              "answer": "After reviewing scope, integrations and support needs, we agree a proposal before work begins."
            },
            {
              "question": "Which languages can we use?",
              "answer": "We work with Armenian and Russian-speaking residents and businesses, with communication in Armenian, Russian and English."
            }
          ]
        },
        "features": {
          "closeButton": "Close",
          "ecommerce": {
            "title": "E-commerce",
            "description": "Online catalogs and shopping workflows suited to your business.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "customDev": {
            "title": "Custom business software",
            "description": "Internal tools, integrations and workflow automation.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "mobileAdaptation": {
            "title": "Websites",
            "description": "Business websites and landing pages adapted for mobile devices.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "scalableArchitecture": {
            "title": "Cloud and server support",
            "description": "Server configuration, deployment, backups and monitoring by agreement.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "creativeDesign": {
            "title": "UI/UX design",
            "description": "Interface design and user journeys for websites and applications.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "effectiveCommunication": {
            "title": "IT maintenance",
            "description": "Website updates, troubleshooting and ongoing technical support.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "onTimeDelivery": {
            "title": "QR menus",
            "description": "Digital menus with content management for restaurants and cafes.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          },
          "collaborativeApproach": {
            "title": "SEO",
            "description": "Technical SEO, site structure and content improvements.",
            "detailedText": "Scope, timing and cost are agreed after reviewing your requirements."
          }
        }
      }
    }
  },
  "lng": "en",
  "fallbackLng": "en",
  "interpolation": {
    "escapeValue": false
  }
});

export default i18n;
